import { render, staticRenderFns } from "./provinceCityAreaEdit.vue?vue&type=template&id=0b95793a&scoped=true&"
import script from "./provinceCityAreaEdit.vue?vue&type=script&lang=ts&"
export * from "./provinceCityAreaEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b95793a",
  null
  
)

export default component.exports